export default {"src":"/_next/static/media/0x2ed9a5c8c13b93955103b9a7c167b67ef4d568a3.da4a3b45.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};